export default "__VITE_ASSET__BIuxpGAn__"